/**
 * Client wrappers around /api/v1/users/* endpoints.
 * All requests automatically carry the Firebase ID token via the
 * axios interceptor in `./api`.
 */
import type { ApiResponse, UpdateUserProfileInput, User } from '@cracked-mug/shared';
import { api } from './api';

function unwrap<T>(payload: ApiResponse<T>): T {
  if (!payload.success) {
    throw new Error(payload.error);
  }
  return payload.data;
}

/** Idempotent — creates the /users/{uid} doc on first sign-in, returns it always. */
export async function bootstrapUser(): Promise<User> {
  const res = await api.post<ApiResponse<User>>('/users/me/bootstrap');
  return unwrap(res.data);
}

export async function getMyProfile(): Promise<User> {
  const res = await api.get<ApiResponse<User>>('/users/me');
  return unwrap(res.data);
}

export async function updateMyProfile(updates: UpdateUserProfileInput): Promise<User> {
  const res = await api.patch<ApiResponse<User>>('/users/me', updates);
  return unwrap(res.data);
}
